import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }               from '../api/api.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { ConfirmService }           from '../messages/confirm/confirm.service';

@Injectable({
  providedIn: 'root'
})
export class PartsAuthorityService {
  title = 'Parts Authority';

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService
  ) {}

  activate () : Promise<void> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
      name: this.title
    }))
    .then(() => this.apiService.get('/company_integration/add_parts_authority'));
  }

  getIntegrations () : Promise<CompanyIntegrationsModel> {
    return this.apiService.get('/company_integrations');
  }

  remove () : Promise<void> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.REMOVE', {
      name: this.title
    }))
    .then(() => this.apiService.get('/company_integration/remove_parts_authority'));
  }

  save ( integrations : CompanyIntegrationsModel ) : Promise<CompanyIntegrationsModel> {
    return this.apiService.patch('/company_integrations', integrations, 'company_integration');
  }
}
